import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { SocialLoginModule, AuthServiceConfig } from 'angular5-social-login';
import { FacebookLoginProvider } from 'angular5-social-login';
import {Simulador} from './classes/simulador';
import { FormularioComponent } from './pages/formulario/formulario.component';
import { PerguntaComponent } from './components/pergunta/pergunta.component';
import { FormsModule } from '@angular/forms';
import { FinalComponent } from './pages/final/final.component';
import { HttpClientModule } from '@angular/common/http';
import { IndexComponent } from './pages/index/index.component';

export function getAuthServiceConfigs() {
  return new AuthServiceConfig([
      {
        id: FacebookLoginProvider.PROVIDER_ID,
        provider: new FacebookLoginProvider('2164112107138570')
      }/*,
      {
        id: GoogleLoginProvider.PROVIDER_ID,
        provider: new GoogleLoginProvider("Your-Google-Client-Id")
      }*/
  ]);
}


@NgModule({
  declarations: [
    AppComponent,
    FormularioComponent,
    PerguntaComponent,
    FinalComponent,
    IndexComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    SocialLoginModule,
    FormsModule,
    HttpClientModule
  ],
  providers: [
    Simulador,
    {
    provide: AuthServiceConfig,
    useFactory: getAuthServiceConfigs
  }],
  bootstrap: [AppComponent]
})
export class AppModule { }
